import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, styled, tableCellClasses, IconButton, Avatar, InputBase, Paper, Button, MenuItem, Menu } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import './requestTable.scss'
import moment from 'moment';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
import SearchIcon from '@mui/icons-material/Search';
import AdminApi from '../../../store/services/admin';
import { StudentActions } from '../../../store/StudentAction';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { createNotifictions } from '../../../utils/helperFunction';
import RequestDetailsModal from './RequestDetailsModal/requestDetailsModal';


function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name: string) {
    return {
        sx: {
            bgcolor: stringToColor(name),
            width: 32,
            height: 32
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}


const RequestTable = (props: any) => {
    const columns = ['Student', 'Status', 'Details', 'PlacementId', 'Actions']
    const [searchText, SetSearchText] = useState("")
    const [requestList, setRequestList] = useState([])
    const [filterText, setFilterText] = useState("All")
    const [status, setStatus] = useState("")
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (props.results.length > 0) setStatus(props.results[0].Status)
        setRequestList(props.results)
    }, [])

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.white,
            color: '#717684',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));
    const searchStudents = (inputText: string) => {
        return requestList.filter((elm: any) => {
            return ("" + elm.Student.name.toLowerCase()).includes(inputText.toLowerCase())
        })

    }
    const switchStatus = (status: string) => {
        switch (status) {
            case "0":
                return <>
                    <div className='flex flex-column'>
                        <div className='flex flex-row justify-content-left mb-2'>
                            <span className='pendingStatus'></span>
                            <p className='font-weight-700 m-0 pendingText'>Pending</p>
                        </div>
                        <div>
                            <p className='font-weight-700 m-0'>{props.approver.result.email}</p>
                            <p className='gray-color m-0'>Approver</p>
                        </div>
                    </div>
                </>
            case "1":
                return <>
                    <div className='flex flex-column'>
                        <div className='flex flex-row justify-content-left mb-2'>
                            <span className='pendingStatus checkColor'></span>
                            <p className='font-weight-700 m-0 checkText'>Approved</p>
                        </div>
                        <div>
                            <p className='font-weight-700 m-0'>{props.approver.result.email}</p>
                            <p className='gray-color m-0'>Approver</p>
                        </div>
                    </div>
                </>
            case "2":
                return <>
                    <div className='flex flex-column'>
                        <div className='flex flex-row justify-content-left mb-2'>
                            <span className='pendingStatus rejectColor'></span>
                            <p className='font-weight-700 m-0 rejectText'>Rejected</p>
                        </div>
                        <div>
                            <p className='font-weight-700 m-0'>{props.approver.result.email}</p>
                            <p className='gray-color m-0'>Approver</p>
                        </div>
                    </div>
                </>
        }
    }
    const FilterConditions = (request: any) => {
        return request.filter((elm: any) => {
            if (filterText === 'All') {
                return elm
            }
            else {
                return elm.code === filterText
            }

        })
    }

    const Details = (props: any) => {
        const switchDetails = () => {
            switch (props.request.code) {
                case 'LR':
                    return (
                        <div className='requestDetailsContainer'>
                            <div className='m-1'>
                                <p className='m-0'>Leave</p>
                                <p className='gray-color m-0 font-thin-Table'>Request</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.DateSubmitted).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>Date Submitted</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.details.leaveFrom).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>From</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.details.leaveTo).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>To</p>
                            </div>
                        </div>
                    )
                case 'DR':
                    return (
                        <div className='requestDetailsContainer'>
                            <div className='m-1'>
                                <p className='m-0'>Placement Date Change</p>
                                <p className='gray-color m-0 font-thin-Table'>Request</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.dateApplied).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>Date Submitted</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.details.newPlacementStart).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>Placement Start</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.details.newPlacementEnd).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>Placement End</p>
                            </div>
                        </div>
                    )
                case 'CP':
                    return (
                        <div className='requestDetailsContainer'>
                            <div className='m-1'>
                                <p className='m-0'>Placement Change</p>
                                <p className='gray-color m-0 font-thin-Table'>Request</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.dateApplied).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>Date Submitted</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{props.request.details.newCompany}</p>
                                <p className='gray-color m-0 font-thin-Table'>Company Name</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{props.request.details.newJobRole}</p>
                                <p className='gray-color m-0 font-thin-Table'>New Role</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.details.newPlacementStart).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>Placement Start</p>
                            </div>
                            <div className='m-1'>
                                <p className='m-0'>{moment(props.request.details.newPlacementEnd).format('D/MM/YYYY')}</p>
                                <p className='gray-color m-0 font-thin-Table'>Placement End</p>
                            </div>
                        </div>
                    )

            }
        }
        return (
            <>
                {switchDetails()}
            </>
        )
    }


    return (
        <div>
            <div className='align-content-center align-items-center flex justify-content-between mb-2'>
                <Paper
                    component="form"
                    className="inputBox searchBox"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search Students"
                        inputProps={{ 'aria-label': 'search students' }}
                        value={searchText}
                        onChange={(e) => {
                            SetSearchText(e.target.value)
                        }}
                    />
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search"  >
                        <SearchIcon />
                    </IconButton>
                </Paper>
                <Button variant="outlined" startIcon={<FilterAltRoundedIcon />} onClick={handleClick}>
                    {filterText}
                </Button>
                <Menu
                    id="filter-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'filter-button',
                    }}
                >
                    <MenuItem onClick={() => {
                        setFilterText('All')
                        handleClose()
                    }}>All</MenuItem>
                    <MenuItem onClick={() => {
                        setFilterText('LR')
                        handleClose()
                    }}>Leave</MenuItem>
                    <MenuItem onClick={() => {
                        setFilterText('DR')
                        handleClose()
                    }}>Placement Date Change</MenuItem>
                    <MenuItem onClick={() => {
                        setFilterText('CP')
                        handleClose()
                    }}>Placement Change</MenuItem>
                </Menu>
            </div>
            <TableContainer sx={{ maxHeight: 440 }} className="tableOuterContainer">
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column: string, index: number) => {
                                return (
                                    column === "Actions" ? status === "0" && <StyledTableCell
                                        key={index}
                                        align='left'
                                        style={{ minWidth: '170px' }}
                                    >
                                        {column}
                                    </StyledTableCell> : <StyledTableCell
                                        key={index}
                                        align='left'
                                        style={{ minWidth: '170px' }}
                                    >
                                        {column}
                                    </StyledTableCell>

                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {searchStudents(searchText).length > 0 ?
                            FilterConditions(searchStudents(searchText))
                                .map((row: any, index: any) => {
                                    return (
                                        <StyledTableRow hover role="checkbox" tabIndex={-1} key={index}>
                                            <StyledTableCell align='left'>
                                                <div className='align-items-start flex'>
                                                    <Avatar  {...stringAvatar(row.Student.name)} />
                                                    <div className='mx-2'>
                                                        <p className='font-weight-700 m-0'>{row.Student.name}</p>
                                                        <p className='subContentTableCell body-p gray-color m-0 subTitle'>{row.Student.studentId}</p>
                                                    </div>
                                                </div>
                                            </StyledTableCell>
                                            <StyledTableCell align="left">{switchStatus(row.Status)}</StyledTableCell>
                                            <StyledTableCell align="left" className='font-weight-700 m-0'>
                                                <Details request={row}></Details>
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className='font-weight-700 m-0'>{row.PlacementId}</StyledTableCell>
                                            {
                                                row.Status === "0" && <StyledTableCell align="left">
                                                    <div className='flex'>
                                                        <RequestDetailsModal req={row} status="1" changeStatus={props.changeStatus}></RequestDetailsModal>
                                                        <RequestDetailsModal req={row} status="2" changeStatus={props.changeStatus}></RequestDetailsModal>
                                                    </div>
                                                </StyledTableCell>
                                            }

                                        </StyledTableRow>
                                    );
                                }) : <>
                                <TableRow>
                                    <TableCell colSpan={6}>
                                        <p className='flex justify-content-left'>No Requests Available.</p>
                                    </TableCell>


                                </TableRow>

                            </>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
export default RequestTable